// DownloadSection.js
import React, { useEffect, useState } from 'react';
import './DownloadSection.css';  // Ensure you have this CSS file for styling
import { CONTENT, DOWNLOAD_LINKS } from '../config/landingPageContent';

const DownloadSection = ({ variant = 'default' }) => {
  const [isMobile, setIsMobile] = useState(false);
  const content = CONTENT[variant] || CONTENT.default;

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPhone|iPad|iPod|Android/i.test(userAgent)) {
      setIsMobile(true);
    }
  }, []); // Empty dependency array to run once on component mount

  const handleDownloadClick = (e) => {
    if (isMobile) {
      // Show an alert if the user is on a mobile device
      alert('This download is only available for macOS. Please visit this page on a macOS device to download.');
      e.preventDefault(); // Prevent default action if on mobile
    } else {
      // Proceed with download if not on mobile
      window.location.href = DOWNLOAD_LINKS.appleSilicon;
    }
  };

  return (
    <div className="download-header">
      <h1>{content.hero.title}</h1>
      <p className="hero-subtitle">{content.hero.subtitle}</p>
      <div className="hero-badges">
        {content.hero.badges.map((badge) => (
          <span className="hero-badge" key={badge}>{badge}</span>
        ))}
      </div>
      <div className="download-container">
        <button
          className="App-button"
          onClick={handleDownloadClick}
        >
          <svg className="download-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
          </svg>
          Download For Apple Silicon
        </button>
      </div>
      <div className="download-note">* Free trial available - No credit card required</div>
    </div>
  );
};

export default DownloadSection;
